import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-develop-challenge-pluses',
  templateUrl: './develop-challenge-pluses.component.html',
  styleUrls: ['./develop-challenge-pluses.component.scss']
})
export class DevelopChallengePlusesComponent {

  constructor(public developChallengeComponent: DevelopChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.developChallengeComponent?.plus_content?.[0] || [];
    this.aiService.openSidebar(
      'develop', 'pluses', context,
      'Generate 5 pluses or advantages {persona} for the proposed solution. Current context: {context}',
      'plus_content', this.developChallengeComponent
    );
  }
}
